import { takeLatest, call } from 'redux-saga/effects';
import {
  fetchRateMarketingInputs,
  addOrUpdateRateMarketingInputs,
} from 'actions/rateMarketingInputs';

import {
  fetchRateMarketingInputsApi,
  addOrUpdateRateMarketingInputsApi,
} from 'services/rateMarketingInputs';

import fetchEntity from './fetch-entity';

const fetchInputs = fetchEntity.bind(null, fetchRateMarketingInputs.actions, fetchRateMarketingInputsApi);
const postInputs = fetchEntity.bind(null, addOrUpdateRateMarketingInputs.actions, addOrUpdateRateMarketingInputsApi);

export function* loadRateMarketingInputs({ params }) {
  yield call(fetchInputs, params);
}

export function* postRateMarketingInputs(action) {
  const payload = action.params.data;
  yield call(postInputs, payload);
}

function* watchRateMarketingInputs() {
  yield takeLatest(fetchRateMarketingInputs.actionName, loadRateMarketingInputs); // If using `.request(...)`
  yield takeLatest(addOrUpdateRateMarketingInputs.actionName, postRateMarketingInputs);
}

export default {
  watchRateMarketingInputs,
};
